var _circle, _ellipse, _path, _path2, _g, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 418,
    height: 431,
    viewBox: "0 0 418 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 209,
    r: 209,
    fill: "#E6B256"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.5,
    cy: 183,
    rx: 198.5,
    ry: 183,
    fill: "#FFC55F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 204.5V226.5C38.1667 220 35.5 208 20.5 208C5.5 208 1.66667 221.167 0 225V364.5C0 377 10.8 392.5 30 410.5C81.5 447 132 423.5 147 415.5C159 409.1 168 395.833 171 390L200.5 339C204.333 331.833 213 315 217 305C221 295 214.667 285.833 211 282.5C209.5 280.667 204.5 276.9 196.5 276.5C188.5 276.1 179.833 284.667 176.5 289L168.5 302V210.5C167.5 204.333 161.8 192 147 192C132.2 192 126.833 205.667 126 212.5L125.5 180.5C124.667 174.667 119.3 163 104.5 163C89.7 163 83.6667 176.667 82.5 183.5V205.5C82.5 197.667 78.3 182.5 61.5 184.5C44.7 186.5 40.5 198.667 40.5 204.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_38",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 163,
    width: 219,
    height: 268
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 204.5V226.5C38.1667 220 35.5 208 20.5 208C5.5 208 1.66667 221.167 0 225V364.5C0 377 10.8 392.5 30 410.5C81.5 447 132 423.5 147 415.5C159 409.1 168 395.833 171 390L200.5 339C204.333 331.833 213 315 217 305C221 295 214.667 285.833 211 282.5C209.5 280.667 204.5 276.9 196.5 276.5C188.5 276.1 179.833 284.667 176.5 289L168.5 302V210.5C167.5 204.333 161.8 192 147 192C132.2 192 126.833 205.667 126 212.5L125.5 180.5C124.667 174.667 119.3 163 104.5 163C89.7 163 83.6667 176.667 82.5 183.5V205.5C82.5 197.667 78.3 182.5 61.5 184.5C44.7 186.5 40.5 198.667 40.5 204.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_38)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5 151C83.8431 151 82.5 152.343 82.5 154V294C82.5 295.657 83.8431 297 85.5 297C87.1569 297 88.5 295.657 88.5 294V154C88.5 152.343 87.1569 151 85.5 151ZM43.5 177C41.8431 177 40.5 178.343 40.5 180V294C40.5 295.657 41.8431 297 43.5 297C45.1569 297 46.5 295.657 46.5 294V180C46.5 178.343 45.1569 177 43.5 177ZM125.5 154C125.5 152.343 126.843 151 128.5 151C130.157 151 131.5 152.343 131.5 154V294C131.5 295.657 130.157 297 128.5 297C126.843 297 125.5 295.657 125.5 294V154ZM2.5 207C0.843145 207 -0.5 208.343 -0.5 210V350H-20L-25.5 421.5L144 453C193 416.333 265.1 355.1 161.5 403.5C57.9 451.9 14.3333 388 5.5 350V210C5.5 208.343 4.15685 207 2.5 207ZM171.5 195C169.843 195 168.5 196.343 168.5 198V338C168.5 339.657 169.843 341 171.5 341C173.157 341 174.5 339.657 174.5 338V198C174.5 196.343 173.157 195 171.5 195Z",
    fill: "#D9D9D9"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259 107.044C274.849 126.593 311.038 151.753 329 96",
    stroke: "black",
    strokeWidth: 21,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147 127.044C162.849 146.593 199.038 171.753 217 116",
    stroke: "black",
    strokeWidth: 21,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218 257C231.333 226.167 272.6 179.7 331 240.5",
    stroke: "black",
    strokeWidth: 21,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.53e3858b101c2d8317d06794466897ed.svg";
export { ForwardRef as ReactComponent };